// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './components/App'
import router from './router'

import project from '../project'

Vue.config.productionTip = false
/* Disable the Vue devtool option on production and staging */
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
  Vue.config.devtools = false
}

/* eslint-disable no-new */
new Vue({
  el: `#app_${project.name}`,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/index.js